import { PolicyStore } from '@Policy/store';
import {
  ComplianceRuleType,
  DlpPolicyItem,
  DlpTemplate,
  MipLabel,
  MipLabelItem,
  TmDpfilterRule,
  TmMipLabelRule,
} from 'src/pages/Policy/utils/types';

export const dlpTemplatesSelector = (state: PolicyStore) => {
  const list = state.dlpTemplates.map((item: DlpTemplate) => ({
    ...item,
    key: item.cfgIndex,
    title: item.dpTemplateName,
    type: ComplianceRuleType.dlpTemplate,
  }));
  return list;
};
export const mipLabelsSelector = (state: PolicyStore): MipLabelItem[] => {
  const list = state.mipLabels.map((item: MipLabel) => ({
    ...item,
    key: item.labelId,
    title: item.labelName,
    type: ComplianceRuleType.mipLabel,
  }));
  return list;
};
export const tmDpfilterrulesSelector = (state: PolicyStore) => {
  const dlpTemplates = state.dlpTemplates;
  const idNameMap = new Map();
  dlpTemplates.forEach((item: DlpTemplate) => {
    idNameMap.set(item.cfgIndex, item.dpTemplateName);
  });
  const template = state.template as DlpPolicyItem;
  const list = template.tmDpfilters.tmDpfilterrules.map(
    (item: TmDpfilterRule) => ({
      id: item.tmDpfiltertemplate.cfgIndex,
      templateName: idNameMap.get(item.tmDpfiltertemplate.cfgIndex),
      dpAction: item.dpAction,
      type: ComplianceRuleType.dlpTemplate,
    })
  );
  return list;
};

export const tmMipLabelRulesSelector = (state: PolicyStore) => {
  const mipLabels = state.mipLabels;
  const idNameMap = new Map();
  mipLabels.forEach((item: MipLabel) => {
    idNameMap.set(item.labelId, item.labelName);
  });
  const template = state.template as DlpPolicyItem;
  const list = template.tmDpfilters.tmMipLabelRules.map(
    (item: TmMipLabelRule) => ({
      id: item.tmMipLabel.labelId,
      templateName: idNameMap.get(item.tmMipLabel.labelId),
      dpAction: item.dpAction,
      type: ComplianceRuleType.mipLabel,
    })
  );
  return list;
};

export const dlpAdvancedOptionConfigSelector = (s: PolicyStore) => {
  const {
    config: {
      defaultValue: {
        tmDpfilters: { dpReplacementText: dpReplacementTextDefault },
      },
    },
  } = s;
  const {
    tmDpfilters: { dpReplacementText },
  } = s.template as DlpPolicyItem;
  const config = {
    replaceFileName: '',
    replaceText: dpReplacementText,
    replaceTextDefault: dpReplacementTextDefault,
  };
  return config;
};

export const dpApprovedSenderEmailEntriesSelector = (state: PolicyStore) => {
  const template = state.template as DlpPolicyItem;
  const entries = template.tmDpfilters.dpApprovedSenderEmailEntries || '';
  const separator = ';';
  return entries
    .split(separator)
    .filter((email: string) => email.trim().length > 0)
    .map((email: string) => ({ value: email.trim(), name: email.trim() }));
};
